import React, { useContext, useEffect, useMemo, useState } from "react";
import Flex from "Trackalyze/Flex";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import { ImportContext } from "~/Context/ImportContext";
import Chip from "Trackalyze/Chip";
import { getActivityDetails } from "~/js/config/activityMapping";
import { useTranslation } from "react-i18next";

const FilterActivitiesContent = ({ standalone }) => {
  const { t } = useTranslation();

  const {
    filterActivities,
    setFilterActivities,
    filterWaypoints,
    filterFavorites, // new
    filterGpxTypes,
    handleFilterTracks,
    searchQuery,
  } = useContext(FilteredTracksContext);

  const { tracksIndex } = useContext(ImportContext);
  const [trackTypes, setTrackTypes] = useState([]);

  // Calculate tracks filtered by waypoints and GPX types
  const tracksFilteredByOthers = useMemo(() => {
    return handleFilterTracks(
      tracksIndex,
      [],
      filterWaypoints,
      filterFavorites || [],
      filterGpxTypes,
      [], // groups
      searchQuery,
    );
  }, [
    tracksIndex,
    filterWaypoints,
    filterFavorites,
    filterGpxTypes,
    handleFilterTracks,
    searchQuery,
  ]);

  // Memoize the calculation of trackTypes to optimize performance
  const memoizedTrackTypes = useMemo(() => {
    if (tracksIndex.length === 0) {
      return [];
    }
    const activityIds = [
      ...new Set(tracksIndex.map((track) => track["info.activity.id"])),
    ];

    // Separate 'unknown' activity
    const unknownActivity = activityIds.find(
      (activity) => activity === "unknown",
    );
    const otherActivities = activityIds
      .filter((activity) => activity !== "unknown")
      .sort();

    // Place 'unknown' at the beginning if it exists
    return unknownActivity
      ? [unknownActivity, ...otherActivities]
      : otherActivities;
  }, [tracksIndex]);

  useEffect(() => {
    setTrackTypes(memoizedTrackTypes);
  }, [memoizedTrackTypes]); // Depend on the memoized value

  const toggleActivityFilter = (activityId) => {
    setFilterActivities((prevFilterActivities) => {
      if (prevFilterActivities.includes(activityId)) {
        return prevFilterActivities.filter((id) => id !== activityId);
      } else {
        return [...prevFilterActivities, activityId];
      }
    });
  };

  return (
    <Flex spacing="1" wrap padding="xxxs">
      {trackTypes.map((activity, idx) => {
        const isSelected = filterActivities.includes(activity);
        const count = tracksFilteredByOthers.filter(
          (t) => t["info.activity.id"] === activity,
        ).length;

        return (
          <Chip
            small
            key={"filteract_id_" + idx}
            disabled={count === 0}
            icon
            selected={isSelected}
            filter
            symbol={getActivityDetails(activity).symbol}
            onClick={() => toggleActivityFilter(activity)}
          >
            {getActivityDetails(activity).label}
            <span
              className={
                "ta-margin_left-xxs " +
                (isSelected ? "" : "ta-color-text_on-surface-variant")
              }
            >
              {count}
            </span>
          </Chip>
        );
      })}
    </Flex>
  );
};

export default React.memo(FilterActivitiesContent); // Consider memoizing this component too
